var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrophone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 11.679c1.972 0 3.572-1.6 3.572-3.572V3.642a3.572 3.572 0 0 0-7.144 0v4.465c0 1.972 1.6 3.572 3.572 3.572"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.143 8.107c0-.492-.4-.893-.893-.893-.492 0-.893.4-.893.893A5.365 5.365 0 0 1 9 13.465a5.365 5.365 0 0 1-5.358-5.358c0-.492-.4-.893-.893-.893-.492 0-.893.4-.893.893 0 3.635 2.732 6.641 6.251 7.08v1.85c0 .492.401.893.893.893s.893-.401.893-.893v-1.85c3.52-.439 6.251-3.445 6.251-7.08"
}))));
export default SvgMicrophone;